import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Pricing() {
  const { t } = useLanguage();

  const plans = [
    { key: 'p1', recommended: false },
    { key: 'p2', recommended: true },
    { key: 'p3', recommended: false },
  ];

  return (
    <section id="pricing" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900">{t('pricing.title')}</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-center">
          {plans.map((plan, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className={`bg-white rounded-3xl p-8 border ${plan.recommended ? 'border-blue-500 shadow-xl shadow-blue-500/10 relative transform md:-translate-y-4' : 'border-gray-200 shadow-sm'}`}
            >
              {plan.recommended && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-500 text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide">
                  POPULAR
                </div>
              )}
              
              <h3 className="text-xl font-bold text-gray-900 mb-2">{t(`pricing.${plan.key}.name`)}</h3>
              <div className="mb-6">
                <span className="text-gray-500 mr-2">{t('pricing.from')}</span>
                <span className="text-4xl font-extrabold text-gray-900">{t(`pricing.${plan.key}.price`)}</span>
              </div>

              <ul className="space-y-4 mb-8">
                {[1, 2, 3].map((f) => (
                  <li key={f} className="flex items-center text-gray-600">
                    <SafeIcon icon={FiCheck} className="text-teal-500 mr-3" />
                    {t(`pricing.${plan.key}.f${f}`)}
                  </li>
                ))}
              </ul>

              <a href="#contact" className={`block text-center w-full py-3 rounded-full font-semibold transition-colors ${plan.recommended ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'}`}>
                {t('hero.cta')}
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}